import styled from "styled-components";
import { ButtonStyledComponent } from "components/button/button.style";
import { TicketIcon } from "components/svgs";
import { ActionButtons } from "styles/bootcamp/bootcamp";

const parentCTALink =
   "https://docs.google.com/forms/d/e/1FAIpQLSdoPhpksu_ELUt8aRg9aZAveKRQ-25GLIvCfcaN8Dq3Y5WfHw/viewform";

export const MediaSection = () => {
   return (
      <Container>
         <YouTubeEmbed
            videoUrl="https://www.youtube.com/watch?v=nFWxh5ia_6k"
            // autoplay={true}
            // startTime={30}
         />
         <ActionButtons style={{ justifyContent: "center", padding: "3rem 0px" }}>
            <ButtonStyledComponent
               as={"a"}
               href={parentCTALink}
               style={{
                  background: "linear-gradient(to right, #CE04F1, #77028B)",
                  color: "white",
                  borderRadius: "35px",
               }}
               variant="unstyled"
               size={"small"}
            >
               <span style={{ paddingRight: "8px" }}>
                  <TicketIcon />
               </span>
               Register to Attend
            </ButtonStyledComponent>
         </ActionButtons>
      </Container>
   );
};

const YouTubeEmbed = ({ videoUrl, autoplay = false, startTime = 0 }) => {
   // Function to extract video ID from various YouTube URL formats
   const getYouTubeId = (url) => {
      const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
      const match = url.match(regExp);
      return match && match[2].length === 11 ? match[2] : null;
   };

   const videoId = getYouTubeId(videoUrl);

   if (!videoId) {
      return <div>Invalid YouTube URL</div>;
   }

   const embedUrl = `https://www.youtube.com/embed/${videoId}?autoplay=${
      autoplay ? 1 : 0
   }&start=${startTime}`;

   return (
      <VideoContainer>
         <VideoIframe
            src={embedUrl}
            title="YouTube video player"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
         />
      </VideoContainer>
   );
};

const Container = styled.div`
   /* background-color: #f8f8f8; */
   padding: 2rem 0;
   max-width: 760px;
   width: 100%;
`;

const VideoContainer = styled.div`
   position: relative;
   width: 100%;
   padding-bottom: 56.25%; /* 16:9 Aspect Ratio */
   height: 0;
   overflow: hidden;
   max-width: 100%;
`;

const VideoIframe = styled.iframe`
   position: absolute;
   top: 0;
   left: 0;
   width: 100%;
   height: 100%;
   border: 0;
`;
